import React, { Fragment, useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';

function Form({ crearReunion }) {

    const [reunion, actulizarReunion] = useState({
        nombreReunion: '',
        nombre: '',
        fecha: '',
        hora: '',
        motivo: ''
    });

    const actulizarState = e => {
        actulizarReunion({
            ...reunion,
            [e.target.name]: e.target.value
        })
    }

    const { nombreReunion, nombre, fecha, hora, motivo } = reunion;

    const [error, actualizarError] = useState(false);

    const submitReunion = e => {
        e.preventDefault();
        //validar

        if (nombreReunion.trim() === '' || nombre.trim() === '' || fecha.trim() === '' || hora.trim() === '' || motivo.trim() === '') {
            actualizarError(true);

            return;
        }
        actualizarError(false);

        //asignar un ID

        reunion.id = uuidv4();

        //Crear la reunion
        crearReunion(reunion)
        //Reniciar formulario
        actulizarReunion({
            nombreReunion: '',
            nombre: '',
            fecha: '',
            hora: '',
            motivo: ''
        })
    }

    return (
        <Fragment>
            <form
                onSubmit={submitReunion}
            >
                <input
                    type="text"
                    placeholder="Nombre de Reunion"
                    name="nombreReunion"
                    onChange={actulizarState}
                    value={nombreReunion}
                />
                <input
                    type="text"
                    placeholder="Nombre del organizador"
                    name="nombre"
                    onChange={actulizarState}
                    value={nombre}
                />
                <input
                    type="date"
                    name="fecha"
                    onChange={actulizarState}
                    value={fecha}
                />
                <input
                    type="time"
                    name="hora"
                    onChange={actulizarState}
                    value={hora}
                />
                <textarea
                    name="motivo"
                    placeholder="Motivo de reunion"
                    onChange={actulizarState}
                    value={motivo}
                ></textarea>
                {error ? <p className="p-error">Se deben llenar todos los campos</p> : null}
                <button
                    type="submit"
                >Crear reunion</button>
            </form>
        </Fragment>
    )
}

Form.propTypes = {
    crearReunion : PropTypes.func.isRequired
  }
  

export default Form
